import { useNavigate } from 'react-router-dom';
import { trackFunnelEvent } from '../../utils/analytics';

interface UpgradePromptProps {
  title: string;
  benefits: string[];
  price: string;
  ctaText: string;
  source?: string;
}

export function UpgradePrompt({ title, benefits, price, ctaText, source = 'upgrade_prompt' }: UpgradePromptProps) {
  const navigate = useNavigate();

  function handleUpgrade() {
    trackFunnelEvent('paywall_hit', { source });
    navigate('/pricing');
  }

  return (
    <div className="card" style={{
      padding: '1.75rem',
      background: 'linear-gradient(135deg, rgba(31,78,95,0.12) 0%, rgba(245,200,66,0.06) 100%)',
      border: '1px solid rgba(245,200,66,0.25)',
      textAlign: 'center',
    }}>
      <p style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>✦</p>
      <h3 style={{ fontFamily: 'var(--font-display)', fontStyle: 'italic', fontWeight: 400, fontSize: 'var(--text-22)', color: 'var(--bg)', margin: '0 0 0.25rem' }}>
        {title}
      </h3>
      <p style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--petrol)', marginBottom: '1.25rem' }}>
        {price}
      </p>

      <ul style={{ listStyle: 'none', margin: '0 0 1.5rem', padding: 0, textAlign: 'left', maxWidth: '360px', marginInline: 'auto' }}>
        {benefits.map((b, i) => (
          <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', marginBottom: '0.5rem', fontSize: 'var(--text-label)', color: 'var(--text-secondary)' }}>
            <span style={{ color: 'var(--petrol)', flexShrink: 0, marginTop: '1px' }}>✓</span>
            {b}
          </li>
        ))}
      </ul>

      <button
        onClick={handleUpgrade}
        className="btn btn-primary"
        style={{ width: '100%', maxWidth: '320px', fontWeight: 700, padding: '0.875rem', fontSize: 'var(--text-label)' }}
      >
        {ctaText}
      </button>
      <p style={{ fontSize: 'var(--text-caption)', color: 'var(--text-muted)', marginTop: '0.75rem' }}>
        ✓ Cancele quando quiser · ✓ Garantia de 7 dias
      </p>
    </div>
  );
}
